import {
  SizeSelection,
  SizeSelection_Size,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useQuantityInBasketBySizeId} from '@aboutyou/user';
import {useMemo} from 'react';

export const useShouldDisableAddToBasketButton = ({
  sizeSelection,
  selectedSizeId,
}: {
  sizeSelection: SizeSelection;
  selectedSizeId?: number;
}) => {
  const sizes: SizeSelection_Size[] | undefined = useMemo(() => {
    switch (sizeSelection.type?.$case) {
      case 'groupedSizes': {
        if (
          sizeSelection.type.groupedSizes.groups[0]?.content?.$case ===
          'sizeRuns'
        ) {
          return sizeSelection.type.groupedSizes.groups[0]?.content.sizeRuns
            .sizeRuns[0]?.sizes;
        } else {
          return sizeSelection.type.groupedSizes.groups[0]?.content?.sizes
            .sizes;
        }
      }
      case 'inlineSelection': {
        return sizeSelection.type.inlineSelection.sizes;
      }
      case 'sizeRuns': {
        return sizeSelection.type.sizeRuns.sizeRuns[0]?.sizes;
      }
      case 'sizes': {
        return sizeSelection.type.sizes.sizes;
      }
      default:
        return undefined;
    }
  }, [sizeSelection]);

  const quantityAddedInBasket = useQuantityInBasketBySizeId(selectedSizeId);

  if (!sizes || !selectedSizeId) {
    return true;
  }

  const selectedSize = sizes.find(size => size.sizeId === selectedSizeId);
  const addedAllAvailableQuantityInTheBasket =
    selectedSize &&
    selectedSize.availability?.$case === 'inStock' &&
    selectedSize.availability.inStock.quantity <= quantityAddedInBasket;

  return (
    sizes.every(size => size.sizeId !== selectedSizeId) ||
    addedAllAvailableQuantityInTheBasket
  );
};
